import { render } from "./DataStep.vue?vue&type=template&id=ccac1cf2&scoped=true"
import script from "./DataStep.vue?vue&type=script&lang=js"
export * from "./DataStep.vue?vue&type=script&lang=js"

import "./DataStep.vue?vue&type=style&index=0&id=ccac1cf2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ccac1cf2"

export default script